import { createContext } from "react";
import type { ProfilierungNodeValidationContextType } from "./types";

const ProfilierungNodeValidationContext =
	createContext<ProfilierungNodeValidationContextType | null>(null);

export default ProfilierungNodeValidationContext;
